import React, { useState, useEffect, useRef } from 'react';
import { get, uniqBy } from 'lodash';
import propTypes from 'prop-types';
import produce from 'immer';
import Router from 'next/router';
import Button from '../../../src/components/ui/Cta';
import styled from '@emotion/styled';
import { theme } from '../../themes/default-theme';
import Text from '../../components/typography';
import { useForm } from "react-hook-form";
import axios from 'axios';
import getSavedPostcode from '../../util/getSavedPostcode';
import ModelOfInterest from '../../containers/Forms/GetAQuoteFormV2/Sections/ModelOfInterest';
import NewModelSelectModal from '../../components/ui/NewModelSelectModal';
import qs from 'qs';
import ReactHtmlParser from 'react-html-parser';
import SelectDealer from '../../containers/Forms/GetAQuoteFormV2/Sections/SelectDealer';
import YourDetails from '../../containers/Forms/GetAQuoteFormV2/Sections/YourDetails';
import ReCAPTCHA from "react-google-recaptcha";
import {sellsMotorhomes, sellsCampervans} from '../../../src/util/filterDealerMotorHomes';

const WrapperAll = styled.div`

`
const Wrapper = styled.div`
  padding-left: 20px;
  padding-right: 20px;
  ${theme.breakpoints.up('md')} {
      padding-left: 40px;
      padding-right: 40px;
  }
`
const Container = styled.div`
  width: 100%;
  max-width: 462px;
  margin: auto;
`
const IntroContainer = styled.div`
  width: 100%;
  max-width: 815px;
  margin: auto;
  h1 {
    text-align: center;
    text-transform: uppercase;
    color: #2E3238;
    margin-bottom: 21px;
    letter-spacing: normal;
  }
  div {
    text-align: center;
    color: #758094;
    font-weight: 400;
  }
  ${theme.breakpoints.up('md')} {
    h1 {
      font-size: 34px;
      line-height: 38px;
    }
    div {
      font-size: 16px;
      line-height: 23px;
    }
  }
  ${theme.breakpoints.down('sm')} {
    h1 {
      letter-spacing: 2px;
      font-size: 32px;
      line-height: 32px;
    }
    div {
      font-size: 14px;
      line-height: 23px;
    }
  }
`
const IntroContainerInner = styled.div`
  ${theme.breakpoints.up('md')} { 
    margin-top: 65px;
  }
  ${theme.breakpoints.down('sm')} {
    margin-top: 56px;
  }
`
const Form = styled.form`

`
const FieldNote = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: #758094;
`

const ButtonContainer = styled.div`
  margin-top: 40px;
  display: block;
  button {
    width: 100%;
    max-width: 200px;
  }
`
const FormItem = styled.div`
  display: block;
  margin:${props => props.margin === 'none' ? `0` : `20px 0`};
  padding-bottom: 20px;
  border-bottom: 1px solid ${theme.palette.middleGrey};
`
const Error = styled.p`
  color: ${theme.palette.error.form};
  ${props => props.alignCenter && `
    text-align: center;
  `}
`

const getAQuoteDefaultPropDealers = [];
const getAQuoteDefaultPropOverlayProps = [];
const getAQuoteDefaultPropFilterOverlayProps = () => {};

const GetAQuote = (props) => {
  props = {
    ...props,
    dealers: typeof props.dealers === "undefined" ? getAQuoteDefaultPropDealers : props.dealers,
    overlayProps: typeof props.overlayProps === "undefined" ? getAQuoteDefaultPropOverlayProps : props.overlayProps,
    filterOverlayProps: typeof props.filterOverlayProps === "undefined" ? getAQuoteDefaultPropFilterOverlayProps : props.filterOverlayProps
  };

  const {
    dealers,
    overlayProps,
    filterOverlayProps
  } = props;

  const [selectDealerFormState, setSelectDealerFormState] = useState({
    postcode: typeof window !== 'undefined' ? getSavedPostcode() : null,
  });
  const [yourDetailsFormState, setYourDetailsFormState] = useState({});
  const [dealersSelect, setDealersSelect] = useState([]);
  const [dealerSummary, setDealerSummary] = useState([]);
  const [rangeOverlayProps, setRangeOverlayProps] = useState(overlayProps)
  const [modelOfInterestState, setModelOfInterestFormState] = useState({});
  const [modelsOfInterest, setModelsOfInterest] = useState([])
  const [modelsOfInterestError, setModelsOfInterestError] = useState(false)
  const [dealersData, setDealersData] = useState(dealers);
  const [motorhomeCapvervans, setMotorhomeCampervans] = useState(false);
  const [sending, setSending] = useState(false);
  const [googleCaptcha, setGoogleCaptcha] = useState(false);
  const [error, setError] = useState(null);
  const [captchaError, setCaptchaError] = useState(null);
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE : process.env.COUNTRY_CODE;
  const country = countryCode === 'AU' ? "Australia" : "New Zealand";
  const [modelError, setModelError] = useState(null);
  const [modal, setModal] = useState(false);
  const containerRef = useRef();
  const recaptchaRef = useRef();
  const modelOfInterestProps = useForm();
  const fieldsProps = useForm();
  const showStock = !process.env.DEALER_SITE || (process.env.DEALER_SITE && get(props, 'router.query.stock', false)) === false ? false : true

  // Methods Start
  const handleChange = async () => {
    if (Object.keys(modelOfInterestProps.errors).length > 0) {
      await modelOfInterestProps.trigger();
    }
    setModelOfInterestFormState(modelOfInterestProps.getValues());

    console.log('fieldsPropsfieldsProps', fieldsProps.getValues());

    if (Object.keys(fieldsProps.errors).length > 0) {
      await fieldsProps.trigger();
    }
    setSelectDealerFormState(fieldsProps.getValues());
    setYourDetailsFormState(fieldsProps.getValues());

  }

  const handleInterestchange = (index, val) => {
    const nextState = produce(modelsOfInterest, draftState => {
      draftState[index] = val
    })
    setModelsOfInterest(nextState);
  }

  const handleAddModel = (model) => {
    const defaultModel = get(model, 'models[0]', model)
    const nextState = produce(modelsOfInterest, draftState => {
      draftState.push(defaultModel)
    })
    setModelsOfInterest(nextState)
    setModal(false)
  }

  const handleRemoveModel = (index) => {
    const nextState = produce(modelsOfInterest, draftState => {
      draftState.splice(index, 1);
    })
    setModelsOfInterest(nextState);
  }

  // if (!showStock) {
  //   return;
  // } 

  const filteredRangeOverlayProps =  filterOverlayProps(rangeOverlayProps, modelsOfInterest);

  const ranges = process.env.DEALER_SITE ? filteredRangeOverlayProps.map(range => {
    const _sellsCampervans = sellsCampervans();
    const _sellsMotorhomes = sellsMotorhomes();

    const models = range.models.filter(item => {

      if (item.title.toLowerCase().indexOf('campervan') !== -1 && !_sellsCampervans ) {
        return false
      }
      if (item.title.toLowerCase().indexOf('motorhome') !== -1 && !_sellsMotorhomes ) {
        return false
      }

      return true;
    });

    return {
      ...range,
      models
    }

  }).filter(item => {
    return item.models.length > 0
  }) : filteredRangeOverlayProps

  const setDefaultDealer = (dealer) => {
    fieldsProps.setValue('dealer', dealer)
  }

  const setDealersSelectItems = (items) => {
    setDealersSelect(uniqBy(items, 'value'));
  }

  const handleSetDealerSummary = (dealer) => {

    const contact = {
      addressLine1: get(dealer, 'acf_dealers.addressLine1', null),
      addressLine2: get(dealer, 'acf_dealers.addressLine2', null),
      phone: get(dealer, 'acf_dealers.phone', null),
      suburb: get(dealer, 'acf_dealers.suburb', null),
      state: get(dealer, 'acf_dealers.state', ''),
      postcode: get(dealer, 'acf_dealers.postcode', ''),
    }

    let addressArr = [];
    contact.addressLine1 && addressArr.push(contact.addressLine1);
    contact.addressLine2 && addressArr.push(contact.addressLine2);
    contact.suburb && addressArr.push(contact.suburb);
    contact.state || contact.postcode && addressArr.push(contact.state ? `${contact.state} ` : '' ` ${contact.postcode ? contact.postcode : ''}`);

    const address = addressArr.join(', ')

    setDealerSummary({
      name: get(dealer, 'title', null),
      address: address,
      phone: contact.phone
    })
  }

  const onSubmit = async data => {
    console.log('data onSubmit', data);

    const recaptchaValue = recaptchaRef.current.getValue();

    const dealerId = process.env.DEALER_SITE && window.staticly.dealerData.id ? {
      dealer: window.staticly.dealerData.id
    } : {}

    const formData = {
      ...data,
      'g-recaptcha-response': googleCaptcha,
      models: modelsOfInterest.map(item => {
        return {
          range: item.rangeTitle,
          series: item.seriesTitle,
          model: item.title
        }
      }),
      form_id: 'get_a_quote',
      ...dealerId
    }

    const valid = modelsOfInterest.length > 0 ? true : false;
    if (valid) {
      if ((googleCaptcha && recaptchaValue.length > 0) && (Object.keys(modelOfInterestProps.errors).length == 0) && (Object.keys(fieldsProps.errors).length == 0)) {
        let formattedData = {};
        let bodyFormData = new FormData();

        Object.keys(formData).forEach(key => {

          if (typeof formData[key] === 'object' && formData[key] && formData[key].value) {
            // For dropdowns
            const value = formData[key].value.toString();
            formattedData[key] = formData[key].value.toString() || ''
            bodyFormData.set(key, value);
            //console.log('dd', formData[key]);
          } else if (typeof formData[key] === 'object' && formData[key] && (!formData[key].value || formData[key].length > 0)) {
            // } else if (typeof formData[key] === 'object' && !get(formData, `[${key}].value`, null) && formData[key] &&formData[key].length > 0) {
            // For models
            formattedData[key] = [];
            for (var i = 0; i < formData[key].length; i++) {
              let item = formData[key][i];
              bodyFormData.append('model[' + i + ']', JSON.stringify(item));
              formattedData[key].push(item);
            }
          } else {
            // For all others
            //console.log('other', formData[key]);
            formattedData[key] = formData[key] ? formData[key].toString() : '';
            bodyFormData.append(key, formData[key] ? formData[key].toString() : '');
          }
        });

        setCaptchaError(null);

        const endpoint = props.formAction ? props.formAction : process.env.STATICLY_FORMS_API_ENDPOINT;

        setSending(true);
        const thankyou = '/get-a-quote/thank-you'

        axios({
          method: 'post',
          url: endpoint,
          data: bodyFormData,
          headers: { 'Content-Type': 'multipart/form-data' }
        })
          .then((response) => {
            console.log('response:', response);
            process.env.NODE_ENV === 'development' ?
              window.location.href = thankyou
              :
              Router.push(thankyou);
          })
          .catch((error) => {
            console.log('Form error: ', error);
            setSending(false);
            setError('Something went wrong. Please try again later.')
          });

      } else {
        setCaptchaError('Google captcha not complete');
        setSending(false)
      }
    } else {
      handleScroll();
      setModelsOfInterestError('Please select a model')
    }
  }

  const handleScroll = () => {
    const { top } = containerRef.current.getBoundingClientRect();
    const position = top + window.pageYOffset
    position ? window.scrollTo({
      top: position,
      behavior: 'smooth'
    }) : containerRef.current.scrollIntoView({ behavior: 'smooth' });
  }
  // Methods End

  // Effect 
  useEffect(() => {
    const qsData = qs.parse(window.location.search.replace('?', ''));

    if (qsData && qsData.items) {
      const items = qsData.items.map(qsItem => {
        const rangeProp = rangeOverlayProps.find(item => item.title.toLowerCase() === qsItem.range.toLowerCase());
        const seriesProp = rangeProp && rangeProp.models ? rangeProp.models.find(item => item.seriesTitle.toLowerCase() === qsItem.series.toLowerCase()) : null;
        const modelProp = seriesProp && seriesProp.models ? seriesProp.models.find(model => (model.title.toLowerCase() === qsItem.model.toLowerCase()) || model.layoutName.toLowerCase() === qsItem.model.toLowerCase()) : null;
        return {
          ...modelProp
        }
      }).filter(item => {
        return item.id ? true : false
      });
      setModelsOfInterest(items);
    }
  }, [])

  useEffect(() => {
    if (modelError) {
      var valid = true;
      for (var i = 0; i < modelsOfInterest.length; i++) {
        var item = modelsOfInterest[i];
        if (item.range === undefined || item.series === undefined) {
          // if (item.range === undefined || item.series  === undefined || item.model  === undefined) {
          valid = false;
          break;
        }
      }
      setModelError(!valid);
    }

    // let motorhomes = false

    // modelsOfInterest.forEach(item => {
    //   if (item.seriesTitle && (item.seriesTitle.toLowerCase().indexOf('motorhome') !== -1 || item.seriesTitle.toLowerCase().indexOf('campervan') !== -1)) {
    //     motorhomes = true
    //   }
    // });

    // const newDealerState = motorhomes ? dealers.filter(item => {
    //   const motorhomesVal = get(item, 'acf_dealers.motorhomes', '0');
    //   return motorhomesVal.toString() === '1'

    // }) : dealers

    let motorhomes = false
    let campervans = false

    modelsOfInterest.forEach(item => {
      if (item.rangeTitle && (item.rangeTitle.toLowerCase() === 'motorhomes')) {
        motorhomes = true
      }
      if (item.rangeTitle.toLowerCase() === 'campervans') {
        campervans = true
      }

    });

    if (motorhomes || campervans) {
      setMotorhomeCampervans(true);
    } else {
      setMotorhomeCampervans(false);
    }

    console.log('modelsOfInterest', {modelsOfInterest, motorhomes, campervans, dealers: props.dealers});

    const newDealerState = props.dealers.filter(item => {
      if (motorhomes && get(item, 'acf_dealers.motorhomes', '0') !== '1') {
        return false;
      }

      if (campervans && get(item, 'acf_dealers.campervans', '0') !== '1' && (item.title && item.title.toLowerCase() !== 'jayco canberra')) {
        return false;
      }

      return true
    })

    setDealersData(newDealerState)
    setDealersSelect([]);
    setDealerSummary([]);
    setSelectDealerFormState({
      ...selectDealerFormState,
      postcode: undefined,
    });
  }, [modelsOfInterest])

  useEffect(() => {
    if (!process.env.DEALER_SITE) {
      setSelectDealerFormState({
        // postcode: dealersData.length > 0 ? getSavedPostcode() : undefined,
      });
      setDealersSelect([]);
      setDealerSummary([]);
    }
  }, [dealersData]);
  // Effect End
  console.log('modelsOfInterest', {modelsOfInterest, ranges});
  return (
    <WrapperAll ref={containerRef}>
      <NewModelSelectModal
        open={modal}
        onSelect={(model) => handleAddModel(model)}
        handleModal={setModal}
        ranges={ranges}
      />
      <Wrapper>
        <IntroContainer>
          <IntroContainerInner>
            {props.title && <Text variant="h1">{props.title}</Text>}
            {props.subTitle && <Text variant="body2">{ReactHtmlParser(props.subTitle)}</Text>}
          </IntroContainerInner>
        </IntroContainer>
        <Container>
          <Form id="get_a_quote" noValidate autoComplete="off" onChange={handleChange}>
            <ModelOfInterest
              formProps={modelOfInterestProps}
              onFormChange={handleChange}
              state={modelOfInterestState}
              countryCode={countryCode}
              ranges={rangeOverlayProps}
              modelsOfInterest={modelsOfInterest}
              onChange={handleInterestchange}
              onAddModel={() => setModal(true)}
              onRemoveModel={handleRemoveModel}
              error={modelError}
              showModelDropdown={!showStock}
              title="Model of Interest"
            />
            {modelsOfInterestError && modelsOfInterest.length == 0 &&
                <Error>{modelsOfInterestError}</Error>
            }
            {!process.env.DEALER_SITE ?
              <SelectDealer
                formProps={fieldsProps}
                onFormChange={handleChange}
                state={selectDealerFormState}
                countryCode={countryCode}
                dealers={dealersData}
                setDefaultDealer={setDefaultDealer}
                setDealersSelect={setDealersSelectItems}
                dealersSelect={dealersSelect}
                setDealerSummary={handleSetDealerSummary}
                title="dealer"
                motorhomeCapvervans={motorhomeCapvervans}
              />
            : <>
              <br />
              <br />
            </>}
            <YourDetails
              formProps={fieldsProps}
              onFormChange={handleChange}
              state={yourDetailsFormState}
              showPostcode={process.env.DEALER_SITE ? true : false}
              country={country}
              title="Your Details"
            />
            <FormItem>
              {process.env.GOOGLE_RECAPTCHA_SITE_KEY &&
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={process.env.GOOGLE_RECAPTCHA_SITE_KEY}
                onChange={setGoogleCaptcha}
              />}
              {!googleCaptcha && captchaError &&
                <Error>{captchaError}</Error>
              }
              {error &&
                <Error>{error}</Error>
              }
            </FormItem>
            <FieldNote>Mandatory*</FieldNote>
            <ButtonContainer>
              <Button inline onClick={fieldsProps.handleSubmit(onSubmit)}>{sending ? 'Submitting...' : 'Submit'}</Button>
            </ButtonContainer>
          </Form>
        </Container>
      </Wrapper>
    </WrapperAll>
  )
}

GetAQuote.propTypes = {
  dealers: propTypes.array,
  overlayProps: propTypes.array,
  filterOverlayProps: propTypes.func
}

export default GetAQuote